import { memo } from "react";
import { useTranslation } from "react-i18next";
import Title from "@/components/Title";
import { List } from "@/components/list/List";
import { DataTableQueryContext } from "@/components/data-table/DataTableQueryContext";
import { costsReadSchema } from "@/schemas/costs";
import { useInvoiceSpecificationCostsQuery } from "../hooks/useInvoiceSpecificationCostsQuery";
import { useInvoiceSpecificationCostsList } from "../hooks/useInvoiceSpecificationCostsList";

interface InvoiceSpecificationCostsSectionProps {
  invoiceSpecificationId: string;
}

const InvoiceSpecificationCostsSectionComponent = ({
  invoiceSpecificationId,
}: InvoiceSpecificationCostsSectionProps) => {
  const { t } = useTranslation();

  const { options, tableFeatures, columnOverrides } =
    useInvoiceSpecificationCostsList(invoiceSpecificationId);

  const { query, queryValue } = useInvoiceSpecificationCostsQuery(
    invoiceSpecificationId,
    options,
  );

  return (
    <List
      schema={costsReadSchema}
      name={"costs"}
      query={query}
      options={options}
      tableFeatures={tableFeatures}
      columnOverrides={columnOverrides}
    >
      <div className="py-2">
        <Title>{t("costs.header")}</Title>
      </div>
      <div>
        <List.Menubar className="mb-2 grow">
          <List.Menubar.Tools />
          <List.Menubar.Columns />
          <List.Menubar.Reset />
        </List.Menubar>
        <DataTableQueryContext.Provider value={queryValue}>
          <List.Content />
        </DataTableQueryContext.Provider>
      </div>
    </List>
  );
};

export const InvoiceSpecificationCostsSection = memo(
  InvoiceSpecificationCostsSectionComponent,
);
